import { render, staticRenderFns } from "./PitchForm.vue?vue&type=template&id=2be7b880"
import script from "./PitchForm.vue?vue&type=script&lang=js"
export * from "./PitchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports